import React, { Children } from 'react';
import debounce from 'lodash.debounce';

export default class FullWidthSection extends React.Component {

  constructor(props) {
    super(props);
    this.pixelTop           = 0;
    this.fullWidthRef       = React.createRef();
    this.changeBurgerColor  = this.changeBurgerColor.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.scrollThreshold = 0;

    this.debouncedScrollListener = debounce(this.onScroll, 100, {
      leading: false,
      trailing: true
    });

  }

  componentDidMount() {
    window.addEventListener('scroll', this.debouncedScrollListener, false);
  }
  
  componentWillUnmount() {
    //console.log('~~~~~~ UNMOUNT FullWidthSection ~~~~~~')
    this.changeBurgerColor('white');
    window.removeEventListener('scroll', this.debouncedScrollListener);
  }

  onScroll() {
    this.fullWidthRef.current.getBoundingClientRect().top - 48 < 0 ? this.changeBurgerColor('#E4B114') : this.changeBurgerColor('white');
  }

  changeBurgerColor(newColor) {
    const { onScrolledOverDifferentColor } = this.props
    onScrolledOverDifferentColor(newColor);
  }

  render() {
    const { children } = this.props
    return (
      <div ref={this.fullWidthRef} className='fullWidth'>
        {children}
      </div>
    )

  }
}